common.View.create('shop::website.partials.shop.Product', {

    ajaxCall: null,

    onDOMLoad() {
        this.initCartSlider();
        this.initAddToCart();
    },

    initCartSlider()
    {
        // Get slider items and check if enough items are found for a slider
        this.element.find('.image').on('mouseenter', (event) => {

            // Slider already added? Or not enough images found?
            if( $(event.currentTarget).find('.mediaSlider .slider').length
                || $(event.currentTarget).find('.mediaSlider.no-slider').length
            ) {
                return;
            }

            // Get slider data from post
            this.ajaxCall = $.post(this.element.data('slider'))
                .done(async (data) => {
                    let $mediaSlider = $(event.currentTarget).find('.mediaSlider');

                    // More than 1 image found?
                    if( data.count > 1 ) {
                        // Add slider to div
                        $mediaSlider.css({
                            'opacity': 0,
                            'display': 'block',
                        });
                        $mediaSlider.html(data.view);

                        let $slider = $mediaSlider.find('.slider');

                        await $slider.owlCarousel({
                            loop: $slider.children().length > 1,
                            startPosition: 1,
                            nav: data.count > 2, //$slider.data('show-navigation'),
                            dots: false, //$slider.data('show-dots') && $slider.children().length > 1,
                            items: 1,
                        });

                        $mediaSlider.css({
                            'opacity': 1,
                        });
                    }
                });
            }).on('mouseleave', (event) => {
                // Fade out and remove html
                $(event.currentTarget).find('.mediaSlider').fadeOut('fast', () => {
                    if( this.ajaxCall ) {
                        this.ajaxCall.abort();
                    }

                    $(event.currentTarget).find('.mediaSlider').html('');
                });
            });

    },

    initAddToCart() {
        this.element

            // Listen to add to cart button click.
            .find('button[name="addToCart"]:enabled')
                .click(this.onAddToCartClick.bind(this))
                .end();
    },

    async onAddToCartClick() {
        // TODO Low: Enable and fix the 'flash' once the next requests executes super fast?
        // Swal.showLoading();

        // Get product variant
        let variant = this.element.find('button[name="addToCart"]:enabled').data('variant'),
            headerInstance = $('.website\\:\\:layouts-main-Header').data('instance'),
            miniCartInstance = $('.shop\\:\\:website-modules-shopCheckout-cart-partials-MiniCart').data('instance');

        // Add clicked class on button
        this.element.find('button[name="addToCart"]')
            .addClass('loading')
            .parent('.actions')
                .addClass('active')
                .end();

        let response = await $.post(variant);

        // Update total amount in header
        headerInstance.setTotalPhysicalAmount(response.totalPhysicalAmount);

        // Add clicked class on button
        this.element.find('button[name="addToCart"]')
            .removeClass('loading')
            .addClass('clicked');

        // Update mini cart
        miniCartInstance.replaceMiniCart(response.miniCartView, false);

        // Remove clicked after x seconds
        setTimeout(() => {
            this.element.find('button[name="addToCart"]')
                .removeClass('clicked')
                .parent('.actions')
                    .removeClass('active')
                    .end();
        }, 2000);

        // TODO Medium: Style
        // Navigate to checkout?
        // if ((await Swal.fire({
        //     title: 'Toegevoegd',
        //     text: 'Het product is toegevoegd aan je winkelmand.',
        //     icon: 'successs',
        //     showCancelButton: true,
        //     cancelButtonColor: '#707070',
        //     cancelButtonText: 'Verder winkelen',
        //     confirmButtonColor: '#4a7729',
        //     confirmButtonText: 'Nu afrekenen'
        // })).value)
        //     document.location.href = this.element.data('checkout-url');
    },

});
